import React, { useState, useContext } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { AuthContext } from '../AuthContext'; // Prilagodi pot
import Swal from 'sweetalert2';

const RequireEmailModal = () => {
    const { user, setUser } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Prikaži SAMO, če je v emailu beseda "missing_" in "@potrebna-sprememba"
    if (!user || !user.email || !user.email.includes('@potrebna-sprememba.com')) {
        return null;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/users/update-missing-email`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: user.id, newEmail: email }),
                credentials: 'include'
            });

            const data = await response.json();

            if (response.ok) {
                // Posodobi uporabnika v aplikaciji (da modal izgine)
                setUser({ ...user, email: email, email_confirmed: true });
                Swal.fire('Uspešno!', 'Email shranjen.', 'success');
            } else {
                setError(data.message || 'Napaka.');
            }
        } catch (err) {
            setError('Napaka strežnika.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={true} backdrop="static" keyboard={false} centered>
            <Modal.Header><Modal.Title>Potreben je email naslov ✉️</Modal.Title></Modal.Header>
            <Modal.Body>
                <p>Facebook nam ni posredoval vašega emaila. Za uporabo platforme ga nujno potrebujemo.</p>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Control
                        type="email" placeholder="Vaš pravi email..." required
                        value={email} onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button type="submit" className="w-100 mt-3" disabled={loading}>Shrani</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};
export default RequireEmailModal;